<ng-container>
  <div class="po-number" id="shared-label-table-conatiner">
    <app-title-subtitle
      [title]="title"
      [titleFontStyle]="titleFontStyle"
      [subtitle]="subtitle"
      [subtitlePadding]="subtitlePadding"
      [subtitleFontStyle]="subtitleFontStyle"
      [showTitleRightIcon]="showIcon"
      [rightTitleIconName]="iconType"
      [rightTitleIconSize]="'1em'"
      [ngClass]="iconColor"
      id="shared-table-title-subtitle"
    ></app-title-subtitle>
  </div>
  <div class="table" [ngStyle]="getCustomStyles()" id="shared-table-wrapper">
    <app-table
      [data]="data"
      [displayedColumnDetails]="displayedColumnDetails"
      [active]="active"
      [footers]="footers"
      [showFooter]="showFooter"
      [headerClassName]="headerClassName"
      [footerClassName]="footerClassName"
      [rowClassName]="rowClassName"
      id="shared-table-content"
    >
    </app-table>
  </div>
</ng-container>
